module.exports = __webpack_public_path__ + "static/media/Zambia_KafueFlats.bb34dcef.jpg";